import React from 'react';
import { Card, CardContent } from './ui/card';
import { Button } from './ui/button';
import { LogOut } from 'lucide-react';
import { AdminLogin } from './admin/AdminLogin';
import { AdminStats } from './admin/AdminStats';
import { InquiryCard } from './admin/InquiryCard';
import useAdminData from '../hooks/useAdminData';

const InquiryList = ({ inquiries, onUpdateStatus }) => (
  <div className="space-y-4">
    <h2 className="text-2xl font-bold text-gray-900">Recent Inquiries</h2>
    {inquiries.length === 0 ? (
      <Card>
        <CardContent className="p-8 text-center text-gray-600">No inquiries yet</CardContent>
      </Card>
    ) : (
      inquiries.map((inquiry) => (
        <InquiryCard key={inquiry.id} inquiry={inquiry} onUpdateStatus={onUpdateStatus} />
      ))
    )}
  </div>
);

const AdminPanel = () => {
  const { isAuthenticated, inquiries, stats, loading, login, logout, updateStatus } = useAdminData();

  if (!isAuthenticated) {
    return <AdminLogin onLogin={login} loading={loading} />;
  }

  return (
    <div className="min-h-screen bg-gradient-to-br from-gray-50 to-cyan-50 p-4 md:p-8">
      <div className="max-w-7xl mx-auto">
        <div className="flex justify-between items-center mb-8">
          <h1 className="text-3xl font-bold text-gray-900">Admin Dashboard</h1>
          <Button onClick={logout} variant="outline" data-testid="admin-logout-btn">
            <LogOut className="w-4 h-4 mr-2" />
            Logout
          </Button>
        </div>

        <AdminStats stats={stats} />
        <InquiryList inquiries={inquiries} onUpdateStatus={updateStatus} />
      </div>
    </div>
  );
};

export default AdminPanel;
